import { useTranslation } from 'next-i18next';

import { localeToHtmlLang } from '@/utils/seo';

/**
 * The BCP 47 tag of the active locale (`pt` -> `pt-BR`, `cn` -> `zh-Hans`, `sa` -> `ar`…), for `Intl`
 * number formatting and localised country names. Falls back to `en` when i18n has no language yet.
 */
export function useHtmlLang(): string {
  const { i18n } = useTranslation();
  return localeToHtmlLang(i18n?.language ?? 'en');
}
